import { DomUtils } from "@tento-ui/dom";
import {
  DecorationPosition,
  DecorationRenderer,
  DecorationRendererContext,
} from "./decoration-renderer.ts";

export class CellSlotDecorationRenderer implements DecorationRenderer {
  #decorations: Map<DecorationPosition, HTMLElement> = new Map();

  readonly #context: DecorationRendererContext;
  constructor(context: DecorationRendererContext) {
    this.#context = context;
  }

  set(decorations: Map<DecorationPosition, HTMLElement>): void {
    for (const [_position, $e] of this.#decorations) {
      DomUtils.removeFromDom($e);
    }

    this.#decorations = decorations;
    this.rebind();
  }

  rebind(): void {
    for (const [position, $e] of this.#decorations) {
      const $cell = this.#context.resolveCell(position);
      $e.slot = "decoration";
      if (!$cell) {
        DomUtils.removeFromDom($e, false);
        continue;
      }
      $cell.appendChild($e);
    }
  }

  clear(): void {
    for (const [_position, $e] of this.#decorations) {
      DomUtils.removeFromDom($e);
    }
    this.#decorations.clear();
  }
}
